import axios from 'axios'
// import crypto from 'crypto'
axios.defaults.baseURL = 'http://111.229.214.104:8000'


const state = {

}

const mutations = {

}

const actions = {
postWxLogin({ commit },data) {
  commit('POST_WX_LOGIN')
  return axios.post('/wxLogin/',data).then((res) => {
    return res
  })
}
}

const getters = {

}

const wxLoginModule = {
  state,
  mutations,
  actions,
  getters
}

export default wxLoginModule
